import React, { useState } from 'react'
import { Navbar } from '../navbar/Navbar'
import { Col, Row } from 'reactstrap'
import { KitchenOrderToken } from './KitchenOrderToken';
import { BarOrderToken } from './BarOrderToken';

export const OrderTokenPage = () => {
    const [selectedMenu, setSelectedMenu] = useState('kitchentoken');

    const renderComponent = () => {
        switch (selectedMenu){
            case 'kitchentoken':
                return <KitchenOrderToken />;
            case 'bartoken':
                return <BarOrderToken /> ;
            default:
                return <KitchenOrderToken />   
        }
    }
  return (
    <>
    <Navbar setSelectedMenu={setSelectedMenu} selectedMenu={selectedMenu} />
    <Row className='w-100 mt-5'>
        <Col md={12} className='mt-2'>
         {renderComponent()}
        </Col>
    </Row>
    </>
  )
}
